import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';


@Injectable()
export class FrontInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    console.log(req.url);
    
    
    if (req.url.includes("/market-place/")) {
        const httpRequest = req.clone({
        headers: new HttpHeaders({
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0'
        })
      });
  
      return next.handle(httpRequest);
    }

    if (localStorage.getItem('jwttoken')) {

      const authHeader = localStorage.getItem('jwttoken');
      let authReq: any;

     
      if (req.method === "POST") {
        if (req.body.toString() === new FormData().toString()) {
          authReq = req.clone({ setHeaders: { Authorization: "Bearer " + authHeader } });
          // setHeaders: {
          //   'Cache-Control': 'no-cache'
          //     Pragma: 'no-cache'
          // }
    
        } else {
          authReq = req.clone({ setHeaders: { Authorization: "Bearer " + authHeader, 'Content-Type': 'application/json' } });
          // setHeaders: {
          //   'Cache-Control': 'no-cache';
          //     Pragma: 'no-cache'
          // }
    
        }
        
      } else {
        authReq = req.clone({ setHeaders: { Authorization: "Bearer " + authHeader, 'Content-Type': 'application/json' } });
      }
      return next.handle(authReq);
    } else if (!req.url.includes("tenant") && localStorage.getItem('tenantIdHeader')) {
      const authReq = req.clone({ setHeaders: { 'tenantIdHeader': localStorage.getItem('tenantIdHeader') } });
      return next.handle(authReq);

    }
    else if (req.url.indexOf('localhost:') >= 0) {

      let TenantContextDto: any = {};
      TenantContextDto.tenantId = 0;
      TenantContextDto.traceId = '9999';
      TenantContextDto.userAgent = '';
      TenantContextDto.userId = 1;
      TenantContextDto.vasTenantId = 1;
      TenantContextDto.vasUserId = 1;
      TenantContextDto.languageId = 1;

      let contextVas = btoa(JSON.stringify(TenantContextDto));

      let httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'vas-context': contextVas
        })
      }
      //'tenantIdHeader': '0',
      const authReq = req.clone({ setHeaders:  { 'Content-Type': 'application/json', 'vas-context': contextVas} });

      return next.handle(authReq);
    }

    
    let TenantContextDto: any = {};
    TenantContextDto.tenantId = 0;
    TenantContextDto.traceId = '9999';
    TenantContextDto.userAgent = '';
    TenantContextDto.userId = 1;
    TenantContextDto.vasTenantId = 1;
    TenantContextDto.vasUserId = 1;
    TenantContextDto.languageId = 1;

    let contextVas = btoa(JSON.stringify(TenantContextDto));

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'vas-context': contextVas
      })
    }
    const authReq = req.clone({ setHeaders: { 'tenantIdHeader': '0' ,'vas-context': contextVas } });

    return next.handle(authReq);

  }
}